/* XENITH CORE 固定購入フッター
   - 高さ確保: ResizeObserver → --xc-spf-h
   - 表示制御: always / after_form(IntersectionObserver) / after_scroll(rAF)
   - バリアント連動: 既存 input[name="id"] の change + dataset(xcName/xcPrice/xcAvailable)
   - 購入: 既存 form[data-xc-product-form] を再利用(同意ゲート/カート追加/遷移は既存ハンドラに委譲) */
(function () {
  'use strict';

  function initFooter(root) {
    if (!root || root.dataset.xcSpfInit) return;
    root.dataset.xcSpfInit = '1';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nameEl = root.querySelector('[data-xc-spf-name]');
    var priceEl = root.querySelector('[data-xc-spf-price]');
    var compareEl = root.querySelector('[data-xc-spf-compare]');
    var cta = root.querySelector('[data-xc-spf-cta]');
    var ctaLabel = root.querySelector('[data-xc-spf-cta-label]');
    var errEl = root.querySelector('[data-xc-spf-error]');
    var mainForm = document.querySelector('[data-xc-purchase] form[data-xc-product-form]') ||
                   document.querySelector('form[data-xc-product-form]');
    var isFixed = root.classList.contains('xc-sticky-purchase--fixed');
    var mode = root.dataset.xcSpfMode || 'after_form';
    var action = root.dataset.xcSpfAction || 'checkout';
    var priorityOnly = root.dataset.xcSpfPriorityOnly === 'true';
    var lockedVariantIds = (root.dataset.xcSpfLockedVariants || '').split(',').filter(Boolean);
    var busy = false;
    var currentInput = null;

    /* ---- 高さ確保(コンテンツを隠さない) ---- */
    if (isFixed) {
      document.documentElement.classList.add('xc-spf-reserve');
      var setH = function () {
        document.documentElement.style.setProperty('--xc-spf-h', root.offsetHeight + 'px');
      };
      /* Shopifyのテーマプレビューバーは画面下64pxを覆う。
         表示中だけ購入バーを上へ逃がし、非表示になれば通常位置へ戻す。 */
      var syncPreviewOffset = function () {
        var previewOffset = document.getElementById('PBarNextFrame') ? 64 : 0;
        root.style.setProperty('--xc-spf-preview-offset', previewOffset + 'px');
        document.documentElement.style.setProperty('--xc-spf-preview-offset', previewOffset + 'px');
        setH();
      };
      if ('ResizeObserver' in window) {
        new ResizeObserver(setH).observe(root);
      } else {
        setH();
        window.addEventListener('resize', setH);
      }
      if ('MutationObserver' in window && document.body) {
        new MutationObserver(syncPreviewOffset).observe(document.body, { childList: true });
      }
      syncPreviewOffset();
    }

    /* ---- 表示制御 ---- */
    function show(on) {
      if (!isFixed) return;
      root.classList.toggle('is-visible', on);
    }
    if (!isFixed || mode === 'always' || !('IntersectionObserver' in window)) {
      show(true);
    } else if (mode === 'after_form' && mainForm) {
      new IntersectionObserver(function (entries) {
        show(!entries[0].isIntersecting);
      }, { threshold: 0 }).observe(mainForm);
    } else if (mode === 'after_scroll') {
      var px = parseInt(root.dataset.xcSpfScrollpx || '600', 10);
      var ticking = false;
      var syncScroll = function () {
        show(window.scrollY > px);
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(syncScroll);
      }, { passive: true });
      syncScroll();
    } else {
      show(true);
    }

    /* ---- バリアント連動 ---- */
    function isPublicVariant(input) {
      return !!input &&
        input.dataset.xcAvailable !== 'false' &&
        input.dataset.xcPublic !== 'false' &&
        input.dataset.xcPriorityLocked !== 'true' &&
        lockedVariantIds.indexOf(String(input.value)) === -1;
    }
    function findPublicVariant() {
      if (!mainForm) return null;
      var selected = mainForm.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
      if (isPublicVariant(selected)) return selected;
      var inputs = mainForm.querySelectorAll('input[name="id"]');
      for (var i = 0; i < inputs.length; i += 1) {
        if (isPublicVariant(inputs[i])) return inputs[i];
      }
      return null;
    }
    function selectPublicVariant() {
      var input = findPublicVariant();
      if (input && input.type === 'radio' && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return input;
    }
    function syncVariant(input) {
      if (!priorityOnly && !isPublicVariant(input)) input = selectPublicVariant();
      currentInput = input;
      if (!input && !priorityOnly) return;
      if (input) {
        if (nameEl && input.dataset.xcName) nameEl.textContent = input.dataset.xcName;
        if (priceEl && input.dataset.xcPrice) priceEl.textContent = input.dataset.xcPrice;
        var inclEl = root.querySelector('[data-xc-spf-incl-price]');
        if (inclEl && input.dataset.xcPriceIncl) inclEl.textContent = input.dataset.xcPriceIncl;
      }
      /* 比較価格はdatasetに無いテーマ構成のため、バリアント切替時は非表示にする(誤表示防止) */
      if (compareEl) compareEl.hidden = true;
      var soldout = !isPublicVariant(input);
      /* 優先販売の在庫開放中(xc.sale_mode=waitlist)はサーバー側指定を最優先で維持する */
      if (cta && cta.hasAttribute('data-xc-spf-forced-waitlist')) soldout = true;
      if (cta) {
        cta.disabled = priorityOnly || soldout || busy;
        if (ctaLabel) ctaLabel.textContent = (priorityOnly || soldout)
            ? (root.dataset.xcSpfSoldout || '売り切れ')
            : (root.dataset.xcSpfLabel || 'ご購入手続きへ進む');
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[data-xc-product-form] input[name="id"]')) {
        syncVariant(e.target);
      }
    });
    if (priorityOnly) syncVariant(null);
    else if (mainForm) syncVariant(selectPublicVariant());

    /* ---- 購入処理 ---- */
    function setBusy(on) {
      busy = on;
      if (!cta) return;
      cta.disabled = on;
      cta.classList.toggle('is-busy', on);
      if (ctaLabel) {
        if (on) {
          ctaLabel.dataset.prev = ctaLabel.textContent;
          ctaLabel.textContent = root.dataset.xcSpfProcessing || '処理中…';
        } else if (ctaLabel.dataset.prev) {
          ctaLabel.textContent = ctaLabel.dataset.prev;
          delete ctaLabel.dataset.prev;
        }
      }
      if (!on) syncVariant(currentInput || selectPublicVariant());
    }
    function fail() {
      setBusy(false);
      if (errEl) {
        errEl.hidden = false;
        setTimeout(function () { errEl.hidden = true; }, 6000);
      }
    }
    if (cta) {
      cta.addEventListener('click', function () {
        if (busy || cta.disabled) return;
        if (errEl) errEl.hidden = true;
        if (priorityOnly) return;
        var act = action;
        /* テーマエディター内では誤遷移させない */
        if (window.Shopify && window.Shopify.designMode && (act === 'checkout' || act === 'cart')) act = 'scroll';
        if (!mainForm || act === 'scroll') {
          var target = mainForm || document.getElementById('xc-buy');
          if (target) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        var checked = selectPublicVariant();
        if (!isPublicVariant(checked)) return;
        /* 個体差同意ゲート未チェック時は既存ハンドラの誘導(スクロール+パルス)に委譲 */
        var ackCb = mainForm.querySelector('[data-xc-ack-cb]');
        if (ackCb && !ackCb.checked) {
          if (mainForm.requestSubmit) mainForm.requestSubmit(); else mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          return;
        }
        if (act === 'checkout' || act === 'submit') {
          /* 既存ハンドラがカート追加→チェックアウト直行まで担当(二重実装しない) */
          setBusy(true);
          if (mainForm.requestSubmit) mainForm.requestSubmit(); else mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          /* 成功時はページ遷移。遷移しなかった場合(エラー)に備えて復帰タイマー */
          setTimeout(function () { setBusy(false); }, 8000);
          return;
        }
        if (act === 'cart') {
          setBusy(true);
          var root2 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root2 + 'cart/add.js', { method: 'POST', body: new FormData(mainForm) })
            .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
            .then(function () {
              document.dispatchEvent(new CustomEvent('xc:cart:added'));
              window.location.href = root2 + 'cart?view=xc';
            })
            .catch(fail);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-xc-spf]').forEach(initFooter);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) ev.target.querySelectorAll('[data-xc-spf]').forEach(initFooter);
  });
})();
